import JobLandingPage from "./LandingPage";

export default JobLandingPage;
